import { useDispatch, useSelector } from 'react-redux'
import { addUtmTrackingResult } from '@store/ducks/utm'
import addUtmTracking from '@client/services/utm'

export default function useUtm() {
  const utm = useSelector(state => state.utmTracking)
  const dispatch = useDispatch()

  async function applyUtm(id) {
    if (!utm.isAlreadySent && utm.values.utmSource) {
      await addUtmTracking(id, utm.values)
      dispatch(addUtmTrackingResult())
    }
  }

  return {
    applyUtm,
    utmQueryParams: utm.queryParams,
  }
}
